module.exports = __webpack_public_path__ + "fonts/brandon_med-webfont-webfont.f2d77fb7aff506c42aacc0941fb72614.woff";